import templateUrl from 'emun.customer/customer-list-map.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'

let component = {
    bindings: {
    },
    require: {
        container: '^customerContainer',
        list: '^customerList'
    },
    controller() {
        basicController(this);
        //this.query = this.list.query;
    },
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default component;